export const environment = {
  production: true,
  type: '${COMERCIAL_BONIFICACAO_ENV_TYPE}',
  webAddress: '${COMERCIAL_BONIFICACAO_FORNECEDORES_NGX_URL}',
  apiAddress: '${COMERCIAL_BONIFICACAO_FORNECEDORES_API_URL}',
};
